export const ADD_SPARKED_ADDRESS = 'ADD_SPARKED_ADDRESS'

export function sparkedAddressReducer(state = "-", action) {
    switch (action.type){
        case ADD_SPARKED_ADDRESS:
            return action.payload
        default: return state
    }
}